import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../services/api';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './Login.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showCodeInput, setShowCodeInput] = useState(false);
  const [resetCode, setResetCode] = useState('');
  const [resetting, setResetting] = useState(false);
  const [resetUrl, setResetUrl] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    setResetUrl('');

    try {
      const response = await authApi.forgotPassword(email);
      
      if (response.data.success) {
        setSuccess(response.data.message || 'Password reset code has been sent to your email address.');
        setShowCodeInput(true);
        if (response.data.reset_url) setResetUrl(response.data.reset_url);
        // In debug mode, show reset code if provided
        if (response.data.reset_code) {
          setSuccess(response.data.message + ' Reset Code: ' + response.data.reset_code);
        }
      } else {
        setError(response.data.message || 'Failed to send password reset code.');
      }
    } catch (err) {
      setError(
        err.response?.data?.message || 
        'Failed to send password reset code. Please try again later.'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setResetting(true);
    setError('');

    if (resetCode.length !== 6) {
      setError('Please enter a valid 6-digit code.');
      setResetting(false);
      return;
    }

    // Navigate to reset password page with email and code
    window.location.href = `/reset-password?email=${encodeURIComponent(email)}&code=${resetCode}`;
  };

  return (
    <>
      <SEO title="Forgot Password" description="Reset your GuyRules account password." canonicalPath="/forgot-password" />
      <Header />
      <div className="container">
        <div className="login-page">
          <h1>Forgot Password</h1>
          
          <p style={{ marginBottom: '1.5rem', color: '#666' }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>

          {error && <div className="error-message">{error}</div>}
          {success && (
            <div className="alert alert-success" style={{ 
              padding: '1rem', 
              backgroundColor: '#d4edda', 
              border: '1px solid #c3e6cb', 
              borderRadius: '4px',
              color: '#155724',
              marginBottom: '1rem'
            }}>
              {success}
              {resetUrl && (
                <div style={{ marginTop: '1rem', padding: '0.75rem', backgroundColor: '#fff', borderRadius: '4px' }}>
                  <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', fontWeight: 'bold' }}>
                    Debug Mode - Reset URL:
                  </p>
                  <a 
                    href={resetUrl} 
                    style={{ 
                      wordBreak: 'break-all', 
                      color: '#0066cc',
                      fontSize: '0.85rem'
                    }}
                  >
                    {resetUrl}
                  </a>
                </div>
              )}
            </div>
          )}

          {!success && (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  disabled={loading}
                  placeholder="Enter your email address"
                />
              </div>

              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
                style={{ width: '100%' }}
              >
                {loading ? 'Sending...' : 'Send Reset Code'}
              </button>
            </form>
          )}

          <p className="register-link" style={{ marginTop: '1rem' }}>
            Remember your password? <Link to="/login">Back to Login</Link>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ForgotPassword;
